import React from 'react';
import Icons from '~/Common-Objects/UI/Icons/index';
export default class HelpLogo extends React.Component {
    render() {
        let style = {
            width: "15px",
            height: "15px",
            display: "inline-block"
        };
        if (this.props.style) style = this.props.style;

        return <Icons icon="questionCircle" {...this.props} style={style} />

    }
}